import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./css/Services.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const resolveImageUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  if (src.startsWith("/uploads/")) return `${API_BASE_URL}${src}`;
  return src;
};

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/services`);
        if (!res.ok) {
          setLoading(false);
          return;
        }
        const data = await res.json();
        setServices(Array.isArray(data.services) ? data.services : []);
      } catch {
        setServices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <section className="services-section">
      <div className="container">
        {/* Header */}
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div className="section-title">
              <h2>حلول استشارية متكاملة من نبض كير</h2>
              <p>
                في نبض كير نقدّم استشارات احترافية تساعد الشركات والأفراد على الامتثال
                للأنظمة، تسريع الإجراءات، وضمان دخول منتجاتهم للأسواق السعودية.
              </p>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="row">
          {loading && <p>جاري تحميل الخدمات...</p>}
          {!loading &&
            services.map((service) => (
              <div className="col-lg-6 col-md-12" key={service.id}>
                <Link to={`/service/${service.id}`} style={{ textDecoration: "none" }}>
                  <div className="service-card">
                    <div className="card-image">
                      {service.image && (
                        <img src={resolveImageUrl(service.image)} alt={service.title} />
                      )}
                    </div>

                    <div className="card-content">
                      <div className="icon-box">
                        <i className="fa-solid fa-arrow-left"></i>
                      </div>

                      <h3>{service.title}</h3>
                      <p>{service.shortDesc}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          {!loading && services.length === 0 && (
            <p className="text-center">لا توجد خدمات متاحة حالياً.</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Services;